import * as React from "react";

import { cn } from "@/lib/utils";

/** Generated at build time by scripts/third-party-notices.mjs and served from the web root. */
export const THIRD_PARTY_NOTICES_URL = "/third-party-notices.txt";

interface Props {
  className?: string;
}

/** Licence attribution the bundled open-source packages require; opens the plain-text notices. */
export const ThirdPartyNoticesLink: React.FC<Props> = ({ className }) => (
  <a
    href={THIRD_PARTY_NOTICES_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={cn("p-2 text-xs text-gray-400 opacity-50 hover:underline hover:opacity-100", className)}
  >
    Third-party notices
  </a>
);
